var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initProductReviews = /* @__PURE__ */ __name(async (sku, filterReviewsRating = 0) => {
  let reviewsData = {};
  const res = await fetch(
    `https://api.trustpilot.com/v1/product-reviews/business-units/4dd3bfa700006400050fb6c0/reviews?apikey=vSHu9w4r6DYCmwN3t7lSl2sqmsrNDvbA&sku=${sku}&perPage=100`
  );
  const data = await res.json();
  reviewsData = data ? data : {};
  const formatReviews = /* @__PURE__ */ __name((data2) => {
    return (data2.productReviews || []).map((review) => {
      const date = new Date(review.createdAt);
      const day = date.getUTCDate();
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getUTCFullYear();
      const formattedDate = `${day} ${month} ${year}`;
      return {
        author: review?.consumer?.displayName || "Anonymous",
        date: formattedDate,
        text: review?.content || "",
        rating: review?.stars
      };
    });
  }, "formatReviews");
  const filteredReviews = filterReviewsRating ? formatReviews(reviewsData)?.filter((review) => review.rating >= filterReviewsRating) : formatReviews(reviewsData);
  const state = window.Alpine.reactive({
    reviews: filteredReviews,
    ratingValue: +Number(
      [...filteredReviews || []].reduce(
        (sum, review) => sum += Number(review?.rating || 0),
        0
      ) / (filteredReviews?.length || 1)
    ).toFixed(1),
    reviewCount: filteredReviews.length
  });
  return {
    ...state
  };
}, "initProductReviews");
window._sections["initProductReviews"] = initProductReviews;
